import { render, staticRenderFns } from "./AdminAuthorizeManager.vue?vue&type=template&id=1395164a&scoped=true&"
import script from "./AdminAuthorizeManager.vue?vue&type=script&lang=js&"
export * from "./AdminAuthorizeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395164a",
  null
  
)

export default component.exports